import ar from './ar.json';
import de from './de.json';
import en from './en.json';
import es from './es.json';
import fr from './fr.json';
import id from './id.json';
import it from './it.json';
import ja from './ja.json';
import ko from './ko.json';
import pt from './pt.json';
import ru from './ru.json';
import th from './th.json';
import tr from './tr.json';
import zh from './zh.json';

const locales = {
  ar,
  de,
  en,
  es,
  fr,
  id,
  it,
  ja,
  ko,
  pt,
  ru,
  th,
  tr,
  zh,
};

export default locales